import axios from "axios";

// export const API_URL = "http://localhost:8070/api";
// export const IMG_URL = "http://localhost:8070/";

//dep

export const API_URL = "https://api.dimfurniture.com.ua/api";
export const IMG_URL = "https://api.dimfurniture.com.ua/";

const $api = axios.create({
  withCredentials: true,
  baseURL: API_URL,
});

$api.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${localStorage.getItem("token")}`;
  return config;
});

$api.interceptors.response.use(
  (config) => {
    return config;
  },
  async (error) => {
    const originalRequest = error.config;
    if (
      error.response.status === 401 &&
      error.config &&
      !error.config._isRetry
    ) {
      originalRequest._isRetry = true;
      try {
        const response = await axios.get(`${API_URL}/refresh_shop`, {
          withCredentials: true,
        });

        localStorage.setItem("token", response.data.acsses);
        return $api.request(originalRequest);
      } catch (e) {
        console.log("not Auth");
        localStorage.removeItem("token");
      }
    }

    throw error;
  }
);

export default $api;
